/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LastSessionTodaySummary } from './LastSessionTodaySummary';
import {
    LastSessionTodaySummaryFromJSON,
    LastSessionTodaySummaryFromJSONTyped,
    LastSessionTodaySummaryToJSON,
    LastSessionTodaySummaryToJSONTyped,
} from './LastSessionTodaySummary';
import type { RecentSession } from './RecentSession';
import {
    RecentSessionFromJSON,
    RecentSessionFromJSONTyped,
    RecentSessionToJSON,
    RecentSessionToJSONTyped,
} from './RecentSession';
import type { SessionInfo } from './SessionInfo';
import {
    SessionInfoFromJSON,
    SessionInfoFromJSONTyped,
    SessionInfoToJSON,
    SessionInfoToJSONTyped,
} from './SessionInfo';
import type { LastSessionUserAverages } from './LastSessionUserAverages';
import {
    LastSessionUserAveragesFromJSON,
    LastSessionUserAveragesFromJSONTyped,
    LastSessionUserAveragesToJSON,
    LastSessionUserAveragesToJSONTyped,
} from './LastSessionUserAverages';

/**
 * 
 * @export
 * @interface LastSessionResponse
 */
export interface LastSessionResponse {
    /**
     * 
     * @type {SessionInfo}
     * @memberof LastSessionResponse
     */
    lastSession?: SessionInfo;
    /**
     * Last 3 gaming sessions
     * @type {Array<RecentSession>}
     * @memberof LastSessionResponse
     */
    recentSessions?: Array<RecentSession>;
    /**
     * 
     * @type {LastSessionTodaySummary}
     * @memberof LastSessionResponse
     */
    todaySummary?: LastSessionTodaySummary;
    /**
     * 
     * @type {LastSessionUserAverages}
     * @memberof LastSessionResponse
     */
    userAverages?: LastSessionUserAverages;
}

/**
 * Check if a given object implements the LastSessionResponse interface.
 */
export function instanceOfLastSessionResponse(value: object): value is LastSessionResponse {
    return true;
}

export function LastSessionResponseFromJSON(json: any): LastSessionResponse {
    return LastSessionResponseFromJSONTyped(json, false);
}

export function LastSessionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LastSessionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'lastSession': json['lastSession'] == null ? undefined : SessionInfoFromJSON(json['lastSession']),
        'recentSessions': json['recentSessions'] == null ? undefined : ((json['recentSessions'] as Array<any>).map(RecentSessionFromJSON)),
        'todaySummary': json['todaySummary'] == null ? undefined : LastSessionTodaySummaryFromJSON(json['todaySummary']),
        'userAverages': json['userAverages'] == null ? undefined : LastSessionUserAveragesFromJSON(json['userAverages']),
    };
}

export function LastSessionResponseToJSON(json: any): LastSessionResponse {
    return LastSessionResponseToJSONTyped(json, false);
}

export function LastSessionResponseToJSONTyped(value?: LastSessionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lastSession': SessionInfoToJSON(value['lastSession']),
        'recentSessions': value['recentSessions'] == null ? undefined : ((value['recentSessions'] as Array<any>).map(RecentSessionToJSON)),
        'todaySummary': LastSessionTodaySummaryToJSON(value['todaySummary']),
        'userAverages': LastSessionUserAveragesToJSON(value['userAverages']),
    };
}

